import { DismissedPopupKeywords } from '../models/kindergarten/dismissed_popup_keywords';
import { KindergartenContract } from './kindergarten.contract';

export interface TeacherContract {
  id: number;
  is_active: boolean;
  groups: string[];
  kindergarten_ids?: number[];
  kindergartens?: KindergartenContract[];
  has_visited_management_app: boolean;
  has_history_enabled?: boolean;
  dismissed_popup_keywords?: DismissedPopupKeywords[];
}
